<template>
  <v-sheet>
    <div id="waveTop"></div>
    <v-container class="py-4 py-lg-8 mt-4 mb-12" style="background-color: white;">
      <h2 style="text-align: center; font-size: 40px">
        {{ $t('products.title') }}
      </h2>
      <v-row>
        <v-card
          v-for="(item, i) in $t('products.obj')"
          :key="i"
          class="d-flex col-6 aling-center mt-6 mb-6"
          max-width="500"
          outlined
          style="margin-left: auto; margin-right: auto; margin-bottom: 10px; border-color: white"
        >
          <v-img
            max-width="100"
            max-height="100"
            :src="obj[i].img"
            alt=""
            style="margin-left: auto; margin-right: auto;"
          >
          </v-img>
          <div class="ml-3">
            <h4>{{ item.title }}</h4>
            <p>{{ item.subtitle }}</p>
            <v-btn
              color="primary"
              class="ma-2 white--text"
              @click="$router.push('/products/' + item.link)"
            >
              {{ $t('products.know') }}
              <v-icon right dark>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
        </v-card>
      </v-row>
    </v-container>
    <div id="waveButton"></div>
  </v-sheet>
</template>

<script>
import Scryptum from 'Assets/Produtos/Scryptum/Scryptum.png';
import Hive from 'Assets/Produtos/Hive/Hive.png';
import Tasset from 'Assets/Produtos/Tasset/Tasset.png';
export default {
  name: 'Specialty',
  data() {
    return {
      obj: [
        {
          img: Scryptum,
        },
        {
          img: Tasset,
        },
        {
          img: Hive,
        },
      ],
    };
  },
  components: {},
};
</script>
